import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { client } from '../common';

type Response = {};
type Variables = {};

export const useCustomerDelete = createMutation<
  Response,
  Variables,
  AxiosError
>({
  mutationFn: async () =>
    client({
      url: `v2/customers`,
      method: 'DELETE',
    })
      .then((response) => {
        console.log('delete customer response', response.data.data);
        return response.data.data;
      })
      .catch((err: any) => {
        throw new Error(err.response.data.errors.join(', '));
      }),
});
